var _commonsHelper = require('./helper');
var _modalTpl = require('./modalTpl');

var Constants = require('./constants');

/**
 * Base module for pop-ups on product page
 */
module.exports = function(cfg) {
	var self = this;

	$.extend(self, cfg);

	var _initPrintButton = function() {
		var $btn = $(self.printBtnSelector, self.$body);

		// Remove the origin onclick handler
		$btn.removeAttr('onclick');

		$btn.off('click').on('click', _print);
	};

	var _print = function() {
		_commonsHelper.printDiv(self.printDivId, 800, 400, _updatePopupStyle);
	};

	var _updatePopupStyle = function(popup) {
		var mainCss = $('link[href*="main.css"]').clone().prop('outerHTML');
		var productPageCss = $('link[href*="product.min.css"]').clone().prop('outerHTML');
		var bootstrapCss = $('link[href*="custom-bootstrap.min.css"]').clone().prop('outerHTML');

		popup.document.getElementsByTagName('head')[0].innerHTML = mainCss + bootstrapCss + productPageCss;
		var style = popup.document.body.style;
		style.minWidth = 0;
		style.width = '740px';
	};

	var _init = function() {	
		var $a = $(self.linkSelector, self.$container);

		$a.off('click').on('click', _openModal);

		_initPrintButton();
	};

	var _openModal = function() {

		_modalTpl.show({
			$container: self.$container,
			title: self.title,
			$body: self.$body,
			show: _show,
			shown: _shown,
			hide: _hide
		});
	};
	
	var _triggerEvt = function(evtName, e) {
		_commonsHelper.trigger(evtName + self.linkSelector, e);
	}

	var _hide = function(e) {
		_triggerEvt(Constants.popupHideEvt, e);
	};

	var _show = function(e) {
		var $dlg = $(e.relatedTarget), 
			dlgCls = self.bodyCls;

		$('.modal-dialog', $dlg).removeClass(dlgCls).addClass(dlgCls);
		$('.modal-footer', $dlg).remove();

		_triggerEvt(Constants.popupShowEvt, e);
	};

	var _shown = function(e) {
		if($.isFunction(cfg.shown)) {
			cfg.shown();
		}

		_triggerEvt(Constants.popupShownEvt, e);
	};

	if(!self.$body) {
		self.$body = $(self.bodySelector).detach();
	}

	_init();
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/commons/popup.js
// module id = 98
// module chunks = 6